/**
 * Trigger a browser download of `data` as a file named `filename`.
 *
 * Owner-free DOM helper, mirrored from `tio-common/utils/download-file` so the
 * tio-data raw-fetch download helpers (search.csv / reports export) can stay
 * dependency-clean — tio-data deliberately does NOT depend on tio-common
 * (ADR-001). Behaviour is byte-for-byte identical to the tio-common copy.
 */
export default function downloadFile(data: BlobPart, filename: string, mime: string): void {
  const blob = new Blob([data], { type: mime || 'application/octet-stream' });

  const blobURL = window.URL.createObjectURL(blob);
  const tempLink = document.createElement('a');
  tempLink.style.display = 'none';
  tempLink.href = blobURL;
  tempLink.setAttribute('download', filename);

  if (typeof tempLink.download === 'undefined') {
    tempLink.setAttribute('target', '_blank');
  }

  document.body.appendChild(tempLink);
  tempLink.click();
  document.body.removeChild(tempLink);
  window.URL.revokeObjectURL(blobURL);
}
